import { render } from "./queDialog.vue?vue&type=template&id=77504d3c&scoped=true"
import script from "./queDialog.vue?vue&type=script&lang=js"
export * from "./queDialog.vue?vue&type=script&lang=js"

import "./queDialog.vue?vue&type=style&index=0&id=77504d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77504d3c"]])

export default __exports__